import React from "react";
import PersonalDataStepShared from "../common/components/PersonalDataStep/PersonalDataStepShared";

/**
 * SUP customer-data step. Thin wrapper over the shared, prop-gated
 * {@link PersonalDataStepShared} (issue #868). SUP collects only the base
 * fields (name / email / phone, + USC for USC partners) and shows an agreement
 * *notice* rather than a checkbox, so it marks the booking as agreed on mount
 * via `showAgreement`.
 */
const PersonalDataStep = () => <PersonalDataStepShared showAgreement />;

export default PersonalDataStep;
